// Mock data for Boidy - Chemical Distribution Company (Ivory Coast)
// Multilingual support: FR, EN, ES, AR

export const companyInfo = {
  name: "Boidy",
  logo: "https://customer-assets.emergentagent.com/job_boidy-transmare/artifacts/tze07bo5_logo%20boidy.png",
  founded: "2019",
  employees: "30+",
  countries: "15+",
  certifications: ["ISO 9001", "API"]
};

// Translations for all content
export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "ACCUEIL",
      about: "À PROPOS",
      markets: "MARCHÉS",
      presence: "PRÉSENCE",
      careers: "CARRIÈRES",
      contact: "CONTACT"
    },
    // Hero Section
    hero: {
      title: "RENDRE NOS CLIENTS",
      subtitle: "EXCEPTIONNELLEMENT PERFORMANTS",
      description: "Votre partenaire de confiance pour la distribution de produits chimiques en Afrique"
    },
    // Values
    values: [
      {
        id: 1,
        title: "PRODUITS DE QUALITÉ",
        icon: "Shield",
        description: "Des produits rigoureusement sélectionnés auprès des meilleurs fabricants."
      },
      {
        id: 2,
        title: "EXCELLENCE DE SERVICE",
        icon: "Award",
        description: "Un engagement total envers la satisfaction de nos clients africains."
      },
      {
        id: 3,
        title: "EXPERTISE LOCALE",
        icon: "TrendingUp",
        description: "Une connaissance approfondie des marchés et réglementations africaines."
      },
      {
        id: 4,
        title: "ORIENTÉ CLIENT",
        icon: "Users",
        description: "Des solutions adaptées aux besoins spécifiques du continent."
      }
    ],
    // Intro
    intro: {
      title: "Votre partenaire en distribution chimique",
      text: "Boidy est un distributeur de produits chimiques de spécialité basé en Côte d'Ivoire. Notre expertise couvre l'ensemble du continent africain avec des solutions sur mesure pour chaque marché. Nous offrons qualité, fiabilité et service de proximité."
    },
    // Markets Section
    marketsSection: {
      title: "MARCHÉS",
      description: "Boidy distribue des produits chimiques de spécialité pour divers secteurs industriels africains. Notre réseau couvre l'Afrique de l'Ouest, Centrale et au-delà."
    },
    markets: [
      {
        id: 1,
        title: "Pharmaceutique",
        slug: "pharmaceutical",
        description: "Excipients, solvants et principes actifs pour l'industrie pharmaceutique africaine.",
        image: "https://images.unsplash.com/photo-1576089275954-40cd98bfcfdb?w=600&h=400&fit=crop"
      },
      {
        id: 2,
        title: "Soins & Cosmétiques",
        slug: "personal-care",
        description: "Additifs et tensioactifs pour produits de soins et cosmétiques locaux.",
        image: "https://images.unsplash.com/photo-1583911860345-9ae84483d7af?w=600&h=400&fit=crop"
      },
      {
        id: 3,
        title: "Agroalimentaire",
        slug: "food",
        description: "Ingrédients alimentaires de qualité pour l'industrie agroalimentaire africaine.",
        image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/bc6s5801_agroalimentaire.png"
      },
      {
        id: 4,
        title: "Divers produits sur demande",
        slug: "various-products",
        description: "Une gamme élargie de produits chimiques de spécialité, disponibles sur demande pour répondre à vos besoins spécifiques.",
        image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/o1optbb4_divers%20produits.png"
      },
      {
        id: 5,
        title: "BTP & Construction",
        slug: "construction",
        description: "Additifs de qualité pour le secteur du bâtiment en pleine croissance.",
        image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop"
      },
      {
        id: 6,
        title: "Peinture",
        slug: "paint",
        description: "Résines, pigments, solvants et additifs pour l'industrie de la peinture et des revêtements décoratifs et industriels.",
        image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/sed8ln2u_Peinture.png"
      },
      {
        id: 7,
        title: "Mines et Énergie",
        slug: "mines-energie",
        description: "Réactifs, lixiviants, floculants et fluides techniques pour l'industrie minière et énergétique africaine.",
        image: "https://images.unsplash.com/photo-1629447388369-760612337eff?w=600&h=400&fit=crop",
        image2: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/1pb47pp2_mines%20et%20energies.png"
      },
      {
        id: 8,
        title: "Traitement des eaux",
        slug: "water",
        description: "Solutions chimiques pour le traitement et la purification de l'eau.",
        image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop"
      }
    ],
    // Global Presence
    presence: {
      title: "CONTACTEZ VOTRE EXPERT LOCAL",
      subtitle: "Notre équipe africaine est à votre service pour des solutions adaptées.",
      buttonText: "TROUVEZ VOTRE EXPERT"
    },
    // Stats
    stats: [
      { id: 1, value: "6+", label: "Années d'expérience" },
      { id: 2, value: "15+", label: "Pays africains" },
      { id: 3, value: "200+", label: "Produits" },
      { id: 4, value: "100+", label: "Clients satisfaits" }
    ],
    // News
    news: {
      title: "DERNIÈRES ACTUALITÉS",
      description: "Découvrez nos nouvelles et réalisations.",
      readMore: "Lire la suite"
    },
    newsItems: [
      {
        id: 1,
        title: "Expansion en Afrique de l'Ouest",
        date: "15/06/2024",
        category: "Général",
        excerpt: "Boidy renforce sa présence au Sénégal et au Mali avec de nouveaux partenariats stratégiques.",
        image: "https://images.unsplash.com/photo-1616804947838-6646ae0e423d?w=400&h=250&fit=crop"
      },
      {
        id: 2,
        title: "Certification ISO 9001 renouvelée",
        date: "23/03/2024",
        category: "Général",
        excerpt: "Notre engagement qualité confirmé par le renouvellement de notre certification internationale.",
        image: "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=400&h=250&fit=crop"
      }
    ],
    // About Page
    about: {
      heroTitle: "À propos de Boidy",
      heroSubtitle: "Un distributeur chimique de référence en Afrique",
      heroDescription: "Boidy est votre partenaire de confiance pour la distribution de produits chimiques en Afrique.",
      section1Title: "Notre histoire",
      section1Text: "Fondée à Abidjan en 2019, Boidy s'est imposée comme un acteur majeur de la distribution chimique en Afrique. Notre connaissance du marché africain et notre réseau étendu nous permettent d'offrir un service de qualité.",
      missionTitle: "Notre Mission",
      missionSubtitle: "Accompagner la croissance industrielle africaine",
      missionText: "Notre mission est de fournir des produits chimiques de qualité aux industries africaines. Nous créons des partenariats durables avec nos clients et fournisseurs pour un développement mutuel."
    },
    // Services
    services: {
      title: "Nos Services",
      subtitle: "NOUS FOURNISSONS LA CHIMIE",
      description: "Infrastructure complète pour répondre à vos besoins.",
      items: [
        {
          id: 1,
          title: "Entreposage",
          description: "Installation moderne à Abidjan avec capacité de stockage adaptée aux besoins africains.",
          features: ["ISO 9001 certifié", "Stockage sécurisé", "Gestion des stocks", "Livraison rapide"]
        },
        {
          id: 2,
          title: "Logistique",
          description: "Réseau logistique couvrant l'Afrique de l'Ouest et Centrale avec partenaires locaux.",
          features: ["Transport régional", "Documentation", "Dédouanement", "Suivi en temps réel"]
        }
      ]
    },
    // Contact
    contact: {
      title: "Contactez-Nous",
      description: "Notre équipe est à votre disposition pour répondre à vos questions.",
      form: {
        company: "Entreprise *",
        name: "Nom *",
        email: "Email *",
        phone: "Téléphone",
        subject: "Sujet *",
        message: "Message *",
        submit: "Envoyer le message",
        sending: "Envoi en cours...",
        success: "Message envoyé !",
        successMessage: "Merci de nous avoir contacté. Nous vous répondrons rapidement."
      },
      subjects: [
        { value: "", label: "Sélectionnez un sujet" },
        { value: "products", label: "Demande de produits" },
        { value: "quote", label: "Demande de devis" },
        { value: "partnership", label: "Partenariat" },
        { value: "careers", label: "Carrières" },
        { value: "other", label: "Autre" }
      ],
      info: {
        title: "Nos coordonnées",
        headquarters: "Siège Social",
        address: "Adresse",
        phone: "Téléphone",
        email: "Email",
        hours: "Horaires",
        hoursValue: "Lundi - Vendredi: 8h00 - 17h00",
        otherOffices: "Bureaux Régionaux"
      }
    },
    // Careers
    careers: {
      title: "Rejoignez Notre Équipe",
      description: "Boidy offre des opportunités de carrière passionnantes en Afrique.",
      whyJoin: "Pourquoi Nous Rejoindre ?",
      benefits: [
        { icon: "Users", title: "Équipe Dynamique", description: "Travaillez avec des professionnels africains passionnés." },
        { icon: "TrendingUp", title: "Croissance", description: "Évoluez dans une entreprise en pleine expansion." },
        { icon: "GraduationCap", title: "Formation", description: "Développez vos compétences continuellement." },
        { icon: "Heart", title: "Bien-être", description: "Environnement de travail positif et inclusif." }
      ],
      jobsTitle: "Offres d'Emploi",
      applyButton: "Postuler",
      spontaneous: {
        title: "Candidature Spontanée",
        description: "Envoyez-nous votre CV pour des opportunités futures.",
        button: "Envoyer ma candidature"
      }
    },
    // Presence Page
    presencePage: {
      title: "Notre Présence en Afrique",
      description: "Basés à Abidjan, nous couvrons l'ensemble du continent africain avec un réseau de partenaires locaux.",
      officesTitle: "Nos Bureaux",
      officesDescription: "Contactez notre équipe pour un service personnalisé.",
      regionsTitle: "Régions Desservies",
      regionsDescription: "Notre réseau couvre les principales économies africaines."
    },
    // Footer
    footer: {
      description: "Votre partenaire de confiance pour la distribution de produits chimiques en Afrique.",
      company: "Entreprise",
      services: "Services",
      legal: "Contact",
      rights: "Tous droits réservés.",
      links: {
        about: "À propos",
        team: "Notre équipe",
        careers: "Carrières",
        news: "Actualités",
        distribution: "Distribution",
        warehouse: "Entreposage",
        logistics: "Logistique",
        solutions: "Solutions sur mesure",
        privacy: "Confidentialité",
        terms: "Conditions",
        cookies: "Cookies"
      }
    },
    // Common
    common: {
      learnMore: "En savoir plus",
      backToMarkets: "Retour aux marchés",
      contactExperts: "Contactez nos experts",
      markets: "Marchés",
      otherMarkets: "Autres marchés"
    },
    partners: {
      eyebrow: "Nos Partenaires",
      title: "Ils nous font confiance",
      description: "Nous collaborons avec des leaders mondiaux de la chimie de spécialité pour garantir la qualité de chaque produit livré à nos clients africains."
    }
  },
  en: {
    nav: {
      home: "HOME",
      about: "ABOUT",
      markets: "MARKETS",
      presence: "PRESENCE",
      careers: "CAREERS",
      contact: "CONTACT"
    },
    hero: {
      title: "MAKING OUR CUSTOMERS",
      subtitle: "EXTREMELY SUCCESSFUL",
      description: "Your trusted partner for chemical distribution in Africa"
    },
    values: [
      { id: 1, title: "QUALITY PRODUCTS", icon: "Shield", description: "Products carefully selected from top manufacturers." },
      { id: 2, title: "SERVICE EXCELLENCE", icon: "Award", description: "Total commitment to our African customers' satisfaction." },
      { id: 3, title: "LOCAL EXPERTISE", icon: "TrendingUp", description: "Deep knowledge of African markets and regulations." },
      { id: 4, title: "CUSTOMER ORIENTED", icon: "Users", description: "Solutions adapted to the continent's specific needs." }
    ],
    intro: {
      title: "Your chemical distribution partner",
      text: "Boidy is a specialty chemicals distributor based in Ivory Coast. Our expertise covers the entire African continent with tailored solutions for each market. We offer quality, reliability and local service."
    },
    marketsSection: {
      title: "MARKETS",
      description: "Boidy distributes specialty chemicals to various African industrial sectors. Our network covers West, Central Africa and beyond."
    },
    markets: [
      { id: 1, title: "Pharmaceutical", slug: "pharmaceutical", description: "Excipients, solvents and APIs for the African pharmaceutical industry.", image: "https://images.unsplash.com/photo-1576089275954-40cd98bfcfdb?w=600&h=400&fit=crop" },
      { id: 2, title: "Care & Cosmetics", slug: "personal-care", description: "Additives and surfactants for local care and cosmetic products.", image: "https://images.unsplash.com/photo-1583911860345-9ae84483d7af?w=600&h=400&fit=crop" },
      { id: 3, title: "Food Industry", slug: "food", description: "Quality food ingredients for the African food industry.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/bc6s5801_agroalimentaire.png" },
      { id: 4, title: "Various Products on Request", slug: "various-products", description: "A wide range of specialty chemicals, available on request to meet your specific needs.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/o1optbb4_divers%20produits.png" },
      { id: 5, title: "Construction", slug: "construction", description: "Quality additives for the growing construction sector.", image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop" },
      { id: 6, title: "Paint", slug: "paint", description: "Resins, pigments, solvents and additives for the paint and decorative & industrial coatings industry.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/sed8ln2u_Peinture.png" },
      { id: 7, title: "Mining & Energy", slug: "mines-energie", description: "Reagents, leaching agents, flocculants and technical fluids for the African mining and energy industry.", image: "https://images.unsplash.com/photo-1629447388369-760612337eff?w=600&h=400&fit=crop", image2: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/1pb47pp2_mines%20et%20energies.png" },
      { id: 8, title: "Water Treatment", slug: "water", description: "Chemical solutions for water treatment and purification.", image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop" }
    ],
    presence: {
      title: "CONTACT YOUR LOCAL EXPERT",
      subtitle: "Our African team is at your service for tailored solutions.",
      buttonText: "FIND YOUR EXPERT"
    },
    stats: [
      { id: 1, value: "6+", label: "Years of experience" },
      { id: 2, value: "15+", label: "African countries" },
      { id: 3, value: "200+", label: "Products" },
      { id: 4, value: "100+", label: "Satisfied customers" }
    ],
    news: {
      title: "LATEST NEWS",
      description: "Discover our news and achievements.",
      readMore: "Read more"
    },
    newsItems: [
      { id: 1, title: "West Africa Expansion", date: "06/15/2024", category: "General", excerpt: "Boidy strengthens its presence in Senegal and Mali with new strategic partnerships.", image: "https://images.unsplash.com/photo-1616804947838-6646ae0e423d?w=400&h=250&fit=crop" },
      { id: 2, title: "ISO 9001 Certification Renewed", date: "03/23/2024", category: "General", excerpt: "Our quality commitment confirmed by the renewal of our international certification.", image: "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=400&h=250&fit=crop" }
    ],
    about: {
      heroTitle: "About Boidy",
      heroSubtitle: "A leading chemical distributor in Africa",
      heroDescription: "Boidy is your trusted partner for chemical distribution in Africa.",
      section1Title: "Our History",
      section1Text: "Founded in Abidjan in 2019, Boidy has established itself as a major player in chemical distribution in Africa. Our knowledge of the African market and our extensive network allow us to offer quality service.",
      missionTitle: "Our Mission",
      missionSubtitle: "Supporting African industrial growth",
      missionText: "Our mission is to provide quality chemicals to African industries. We create lasting partnerships with our customers and suppliers for mutual development."
    },
    services: {
      title: "Our Services",
      subtitle: "WE SUPPLY CHEMISTRY",
      description: "Complete infrastructure to meet your needs.",
      items: [
        { id: 1, title: "Warehousing", description: "Modern facility in Abidjan with storage capacity adapted to African needs.", features: ["ISO 9001 certified", "Secure storage", "Inventory management", "Fast delivery"] },
        { id: 2, title: "Logistics", description: "Logistics network covering West and Central Africa with local partners.", features: ["Regional transport", "Documentation", "Customs clearance", "Real-time tracking"] }
      ]
    },
    contact: {
      title: "Contact Us",
      description: "Our team is available to answer your questions.",
      form: {
        company: "Company *",
        name: "Name *",
        email: "Email *",
        phone: "Phone",
        subject: "Subject *",
        message: "Message *",
        submit: "Send message",
        sending: "Sending...",
        success: "Message sent!",
        successMessage: "Thank you for contacting us. We will respond shortly."
      },
      subjects: [
        { value: "", label: "Select a subject" },
        { value: "products", label: "Product inquiry" },
        { value: "quote", label: "Quote request" },
        { value: "partnership", label: "Partnership" },
        { value: "careers", label: "Careers" },
        { value: "other", label: "Other" }
      ],
      info: {
        title: "Our contact details",
        headquarters: "Headquarters",
        address: "Address",
        phone: "Phone",
        email: "Email",
        hours: "Hours",
        hoursValue: "Monday - Friday: 8:00 AM - 5:00 PM",
        otherOffices: "Regional Offices"
      }
    },
    careers: {
      title: "Join Our Team",
      description: "Boidy offers exciting career opportunities in Africa.",
      whyJoin: "Why Join Us?",
      benefits: [
        { icon: "Users", title: "Dynamic Team", description: "Work with passionate African professionals." },
        { icon: "TrendingUp", title: "Growth", description: "Evolve in a rapidly expanding company." },
        { icon: "GraduationCap", title: "Training", description: "Continuously develop your skills." },
        { icon: "Heart", title: "Well-being", description: "Positive and inclusive work environment." }
      ],
      jobsTitle: "Job Openings",
      applyButton: "Apply",
      spontaneous: {
        title: "Spontaneous Application",
        description: "Send us your CV for future opportunities.",
        button: "Send my application"
      }
    },
    presencePage: {
      title: "Our Presence in Africa",
      description: "Based in Abidjan, we cover the entire African continent with a network of local partners.",
      officesTitle: "Our Offices",
      officesDescription: "Contact our team for personalized service.",
      regionsTitle: "Regions Served",
      regionsDescription: "Our network covers major African economies."
    },
    footer: {
      description: "Your trusted partner for chemical distribution in Africa.",
      company: "Company",
      services: "Services",
      legal: "Contact",
      rights: "All rights reserved.",
      links: {
        about: "About",
        team: "Our team",
        careers: "Careers",
        news: "News",
        distribution: "Distribution",
        warehouse: "Warehousing",
        logistics: "Logistics",
        solutions: "Custom solutions",
        privacy: "Privacy",
        terms: "Terms",
        cookies: "Cookies"
      }
    },
    common: {
      learnMore: "Learn more",
      backToMarkets: "Back to markets",
      contactExperts: "Contact our experts",
      markets: "Markets",
      otherMarkets: "Other markets"
    },
    partners: {
      eyebrow: "Our Partners",
      title: "They trust us",
      description: "We work alongside world-leading specialty chemistry companies to guarantee the quality of every product we deliver to our African customers."
    }
  },
  es: {
    nav: {
      home: "INICIO",
      about: "NOSOTROS",
      markets: "MERCADOS",
      presence: "PRESENCIA",
      careers: "CARRERAS",
      contact: "CONTACTO"
    },
    hero: {
      title: "HACIENDO A NUESTROS CLIENTES",
      subtitle: "EXCEPCIONALMENTE EXITOSOS",
      description: "Su socio de confianza para la distribución química en África"
    },
    values: [
      { id: 1, title: "PRODUCTOS DE CALIDAD", icon: "Shield", description: "Productos cuidadosamente seleccionados de los mejores fabricantes." },
      { id: 2, title: "EXCELENCIA EN SERVICIO", icon: "Award", description: "Compromiso total con la satisfacción de nuestros clientes africanos." },
      { id: 3, title: "EXPERIENCIA LOCAL", icon: "TrendingUp", description: "Conocimiento profundo de los mercados y regulaciones africanas." },
      { id: 4, title: "ORIENTADO AL CLIENTE", icon: "Users", description: "Soluciones adaptadas a las necesidades específicas del continente." }
    ],
    intro: {
      title: "Su socio en distribución química",
      text: "Boidy es un distribuidor de productos químicos especializados con sede en Costa de Marfil. Nuestra experiencia cubre todo el continente africano con soluciones a medida. Ofrecemos calidad, confiabilidad y servicio local."
    },
    marketsSection: {
      title: "MERCADOS",
      description: "Boidy distribuye productos químicos especializados para diversos sectores industriales africanos. Nuestra red cubre África Occidental, Central y más allá."
    },
    markets: [
      { id: 1, title: "Farmacéutico", slug: "pharmaceutical", description: "Excipientes, solventes y APIs para la industria farmacéutica africana.", image: "https://images.unsplash.com/photo-1576089275954-40cd98bfcfdb?w=600&h=400&fit=crop" },
      { id: 2, title: "Cuidado & Cosmética", slug: "personal-care", description: "Aditivos y tensioactivos para productos de cuidado y cosméticos locales.", image: "https://images.unsplash.com/photo-1583911860345-9ae84483d7af?w=600&h=400&fit=crop" },
      { id: 3, title: "Alimentario", slug: "food", description: "Ingredientes alimentarios de calidad para la industria africana.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/bc6s5801_agroalimentaire.png" },
      { id: 4, title: "Diversos productos bajo pedido", slug: "various-products", description: "Una amplia gama de productos químicos especializados, disponibles bajo pedido para sus necesidades específicas.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/o1optbb4_divers%20produits.png" },
      { id: 5, title: "Construcción", slug: "construction", description: "Aditivos de calidad para el sector de construcción en crecimiento.", image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop" },
      { id: 6, title: "Pintura", slug: "paint", description: "Resinas, pigmentos, solventes y aditivos para la industria de pinturas y revestimientos decorativos e industriales.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/sed8ln2u_Peinture.png" },
      { id: 7, title: "Minería y Energía", slug: "mines-energie", description: "Reactivos, lixiviantes, floculantes y fluidos técnicos para la industria minera y energética africana.", image: "https://images.unsplash.com/photo-1629447388369-760612337eff?w=600&h=400&fit=crop", image2: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/1pb47pp2_mines%20et%20energies.png" },
      { id: 8, title: "Tratamiento de Agua", slug: "water", description: "Soluciones químicas para tratamiento y purificación de agua.", image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop" }
    ],
    presence: {
      title: "CONTACTE A SU EXPERTO LOCAL",
      subtitle: "Nuestro equipo africano está a su servicio para soluciones adaptadas.",
      buttonText: "ENCUENTRE SU EXPERTO"
    },
    stats: [
      { id: 1, value: "6+", label: "Años de experiencia" },
      { id: 2, value: "15+", label: "Países africanos" },
      { id: 3, value: "200+", label: "Productos" },
      { id: 4, value: "100+", label: "Clientes satisfechos" }
    ],
    news: {
      title: "ÚLTIMAS NOTICIAS",
      description: "Descubra nuestras novedades y logros.",
      readMore: "Leer más"
    },
    newsItems: [
      { id: 1, title: "Expansión en África Occidental", date: "15/06/2024", category: "General", excerpt: "Boidy refuerza su presencia en Senegal y Mali con nuevas alianzas estratégicas.", image: "https://images.unsplash.com/photo-1616804947838-6646ae0e423d?w=400&h=250&fit=crop" },
      { id: 2, title: "Certificación ISO 9001 Renovada", date: "23/03/2024", category: "General", excerpt: "Nuestro compromiso con la calidad confirmado por la renovación de nuestra certificación.", image: "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=400&h=250&fit=crop" }
    ],
    about: {
      heroTitle: "Sobre Boidy",
      heroSubtitle: "Un distribuidor químico líder en África",
      heroDescription: "Boidy es su socio de confianza para la distribución química en África.",
      section1Title: "Nuestra Historia",
      section1Text: "Fundada en Abidján en 2019, Boidy se ha establecido como un actor importante en la distribución química en África. Nuestro conocimiento del mercado africano nos permite ofrecer servicio de calidad.",
      missionTitle: "Nuestra Misión",
      missionSubtitle: "Apoyar el crecimiento industrial africano",
      missionText: "Nuestra misión es proveer productos químicos de calidad a las industrias africanas. Creamos alianzas duraderas con clientes y proveedores para desarrollo mutuo."
    },
    services: {
      title: "Nuestros Servicios",
      subtitle: "SUMINISTRAMOS QUÍMICA",
      description: "Infraestructura completa para sus necesidades.",
      items: [
        { id: 1, title: "Almacenamiento", description: "Instalación moderna en Abidján con capacidad adaptada a necesidades africanas.", features: ["Certificado ISO 9001", "Almacenamiento seguro", "Gestión de inventario", "Entrega rápida"] },
        { id: 2, title: "Logística", description: "Red logística cubriendo África Occidental y Central con socios locales.", features: ["Transporte regional", "Documentación", "Despacho aduanero", "Seguimiento en tiempo real"] }
      ]
    },
    contact: {
      title: "Contáctenos",
      description: "Nuestro equipo está disponible para responder sus preguntas.",
      form: {
        company: "Empresa *",
        name: "Nombre *",
        email: "Email *",
        phone: "Teléfono",
        subject: "Asunto *",
        message: "Mensaje *",
        submit: "Enviar mensaje",
        sending: "Enviando...",
        success: "¡Mensaje enviado!",
        successMessage: "Gracias por contactarnos. Le responderemos pronto."
      },
      subjects: [
        { value: "", label: "Seleccione un asunto" },
        { value: "products", label: "Consulta de productos" },
        { value: "quote", label: "Solicitud de cotización" },
        { value: "partnership", label: "Alianza" },
        { value: "careers", label: "Carreras" },
        { value: "other", label: "Otro" }
      ],
      info: {
        title: "Nuestros datos de contacto",
        headquarters: "Sede Central",
        address: "Dirección",
        phone: "Teléfono",
        email: "Email",
        hours: "Horario",
        hoursValue: "Lunes - Viernes: 8:00 - 17:00",
        otherOffices: "Oficinas Regionales"
      }
    },
    careers: {
      title: "Únase a Nuestro Equipo",
      description: "Boidy ofrece oportunidades de carrera emocionantes en África.",
      whyJoin: "¿Por Qué Unirse a Nosotros?",
      benefits: [
        { icon: "Users", title: "Equipo Dinámico", description: "Trabaje con profesionales africanos apasionados." },
        { icon: "TrendingUp", title: "Crecimiento", description: "Evolucione en una empresa en rápida expansión." },
        { icon: "GraduationCap", title: "Formación", description: "Desarrolle continuamente sus habilidades." },
        { icon: "Heart", title: "Bienestar", description: "Ambiente de trabajo positivo e inclusivo." }
      ],
      jobsTitle: "Ofertas de Empleo",
      applyButton: "Aplicar",
      spontaneous: {
        title: "Candidatura Espontánea",
        description: "Envíenos su CV para futuras oportunidades.",
        button: "Enviar mi candidatura"
      }
    },
    presencePage: {
      title: "Nuestra Presencia en África",
      description: "Con sede en Abidján, cubrimos todo el continente africano con una red de socios locales.",
      officesTitle: "Nuestras Oficinas",
      officesDescription: "Contacte a nuestro equipo para servicio personalizado.",
      regionsTitle: "Regiones Atendidas",
      regionsDescription: "Nuestra red cubre las principales economías africanas."
    },
    footer: {
      description: "Su socio de confianza para la distribución química en África.",
      company: "Empresa",
      services: "Servicios",
      legal: "Contacto",
      rights: "Todos los derechos reservados.",
      links: {
        about: "Nosotros",
        team: "Nuestro equipo",
        careers: "Carreras",
        news: "Noticias",
        distribution: "Distribución",
        warehouse: "Almacenamiento",
        logistics: "Logística",
        solutions: "Soluciones a medida",
        privacy: "Privacidad",
        terms: "Términos",
        cookies: "Cookies"
      }
    },
    common: {
      learnMore: "Más información",
      backToMarkets: "Volver a mercados",
      contactExperts: "Contacte a nuestros expertos",
      markets: "Mercados",
      otherMarkets: "Otros mercados"
    },
    partners: {
      eyebrow: "Nuestros Socios",
      title: "Confían en nosotros",
      description: "Colaboramos con líderes mundiales de la química de especialidad para garantizar la calidad de cada producto entregado a nuestros clientes africanos."
    }
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "من نحن",
      markets: "الأسواق",
      presence: "التواجد",
      careers: "الوظائف",
      contact: "اتصل بنا"
    },
    hero: {
      title: "نجعل عملاءنا",
      subtitle: "ناجحين بشكل استثنائي",
      description: "شريكك الموثوق لتوزيع المواد الكيميائية في أفريقيا"
    },
    values: [
      { id: 1, title: "منتجات عالية الجودة", icon: "Shield", description: "منتجات مختارة بعناية من أفضل الشركات المصنعة." },
      { id: 2, title: "التميز في الخدمة", icon: "Award", description: "التزام كامل برضا عملائنا الأفارقة." },
      { id: 3, title: "الخبرة المحلية", icon: "TrendingUp", description: "معرفة عميقة بالأسواق واللوائح الأفريقية." },
      { id: 4, title: "موجه للعميل", icon: "Users", description: "حلول مصممة لاحتياجات القارة الخاصة." }
    ],
    intro: {
      title: "شريكك في التوزيع الكيميائي",
      text: "بويدي هي موزع للمواد الكيميائية المتخصصة مقرها ساحل العاج. خبرتنا تغطي القارة الأفريقية بأكملها مع حلول مخصصة. نقدم الجودة والموثوقية والخدمة المحلية."
    },
    marketsSection: {
      title: "الأسواق",
      description: "توزع بويدي المواد الكيميائية المتخصصة لمختلف القطاعات الصناعية الأفريقية. تغطي شبكتنا غرب ووسط أفريقيا وما بعدها."
    },
    markets: [
      { id: 1, title: "الأدوية", slug: "pharmaceutical", description: "السواغات والمذيبات للصناعة الدوائية الأفريقية.", image: "https://images.unsplash.com/photo-1576089275954-40cd98bfcfdb?w=600&h=400&fit=crop" },
      { id: 2, title: "العناية والتجميل", slug: "personal-care", description: "إضافات ومواد خافضة للتوتر السطحي لمنتجات العناية المحلية.", image: "https://images.unsplash.com/photo-1583911860345-9ae84483d7af?w=600&h=400&fit=crop" },
      { id: 3, title: "الصناعات الغذائية", slug: "food", description: "مكونات غذائية عالية الجودة للصناعة الأفريقية.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/bc6s5801_agroalimentaire.png" },
      { id: 4, title: "منتجات متنوعة عند الطلب", slug: "various-products", description: "مجموعة واسعة من المواد الكيميائية المتخصصة، متاحة عند الطلب لتلبية احتياجاتك الخاصة.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/o1optbb4_divers%20produits.png" },
      { id: 5, title: "البناء", slug: "construction", description: "إضافات عالية الجودة لقطاع البناء المتنامي.", image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&h=400&fit=crop" },
      { id: 6, title: "الطلاء", slug: "paint", description: "راتنجات وأصباغ ومذيبات ومضافات لصناعة الطلاء والدهانات الزخرفية والصناعية.", image: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/sed8ln2u_Peinture.png" },
      { id: 7, title: "التعدين والطاقة", slug: "mines-energie", description: "كواشف ومواد رشح ومواد تلبد وسوائل تقنية لصناعة التعدين والطاقة في أفريقيا.", image: "https://images.unsplash.com/photo-1629447388369-760612337eff?w=600&h=400&fit=crop", image2: "https://customer-assets.emergentagent.com/job_f79f1573-be7d-47b7-99e2-70d1f8759bc8/artifacts/1pb47pp2_mines%20et%20energies.png" },
      { id: 8, title: "معالجة المياه", slug: "water", description: "حلول كيميائية لمعالجة وتنقية المياه.", image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop" }
    ],
    presence: {
      title: "تواصل مع خبيرك المحلي",
      subtitle: "فريقنا الأفريقي في خدمتك لحلول مخصصة.",
      buttonText: "ابحث عن خبيرك"
    },
    stats: [
      { id: 1, value: "+6", label: "سنوات من الخبرة" },
      { id: 2, value: "+15", label: "دولة أفريقية" },
      { id: 3, value: "+200", label: "منتج" },
      { id: 4, value: "+100", label: "عميل راضٍ" }
    ],
    news: {
      title: "آخر الأخبار",
      description: "اكتشف أخبارنا وإنجازاتنا.",
      readMore: "اقرأ المزيد"
    },
    newsItems: [
      { id: 1, title: "التوسع في غرب أفريقيا", date: "15/06/2024", category: "عام", excerpt: "بويدي تعزز تواجدها في السنغال ومالي بشراكات استراتيجية جديدة.", image: "https://images.unsplash.com/photo-1616804947838-6646ae0e423d?w=400&h=250&fit=crop" },
      { id: 2, title: "تجديد شهادة ISO 9001", date: "23/03/2024", category: "عام", excerpt: "التزامنا بالجودة مؤكد بتجديد شهادتنا الدولية.", image: "https://images.unsplash.com/photo-1582719471137-c3967ffb1c42?w=400&h=250&fit=crop" }
    ],
    about: {
      heroTitle: "عن بويدي",
      heroSubtitle: "موزع كيميائي رائد في أفريقيا",
      heroDescription: "بويدي شريكك الموثوق للتوزيع الكيميائي في أفريقيا.",
      section1Title: "تاريخنا",
      section1Text: "تأسست في أبيدجان عام 2019، أصبحت بويدي لاعباً رئيسياً في التوزيع الكيميائي في أفريقيا. معرفتنا بالسوق الأفريقي تمكننا من تقديم خدمة عالية الجودة.",
      missionTitle: "مهمتنا",
      missionSubtitle: "دعم النمو الصناعي الأفريقي",
      missionText: "مهمتنا توفير مواد كيميائية عالية الجودة للصناعات الأفريقية. نبني شراكات دائمة مع عملائنا وموردينا للتطور المتبادل."
    },
    services: {
      title: "خدماتنا",
      subtitle: "نوفر الكيمياء",
      description: "بنية تحتية كاملة لتلبية احتياجاتك.",
      items: [
        { id: 1, title: "التخزين", description: "منشأة حديثة في أبيدجان بسعة تخزين مناسبة للاحتياجات الأفريقية.", features: ["معتمد ISO 9001", "تخزين آمن", "إدارة المخزون", "توصيل سريع"] },
        { id: 2, title: "اللوجستيات", description: "شبكة لوجستية تغطي غرب ووسط أفريقيا مع شركاء محليين.", features: ["نقل إقليمي", "توثيق", "تخليص جمركي", "تتبع فوري"] }
      ]
    },
    contact: {
      title: "اتصل بنا",
      description: "فريقنا متاح للإجابة على أسئلتك.",
      form: {
        company: "الشركة *",
        name: "الاسم *",
        email: "البريد الإلكتروني *",
        phone: "الهاتف",
        subject: "الموضوع *",
        message: "الرسالة *",
        submit: "إرسال الرسالة",
        sending: "جاري الإرسال...",
        success: "تم إرسال الرسالة!",
        successMessage: "شكراً لتواصلك معنا. سنرد عليك قريباً."
      },
      subjects: [
        { value: "", label: "اختر موضوعاً" },
        { value: "products", label: "استفسار عن المنتجات" },
        { value: "quote", label: "طلب عرض سعر" },
        { value: "partnership", label: "شراكة" },
        { value: "careers", label: "وظائف" },
        { value: "other", label: "أخرى" }
      ],
      info: {
        title: "بيانات الاتصال",
        headquarters: "المقر الرئيسي",
        address: "العنوان",
        phone: "الهاتف",
        email: "البريد الإلكتروني",
        hours: "ساعات العمل",
        hoursValue: "الإثنين - الجمعة: 8:00 - 17:00",
        otherOffices: "المكاتب الإقليمية"
      }
    },
    careers: {
      title: "انضم إلى فريقنا",
      description: "بويدي تقدم فرص عمل مثيرة في أفريقيا.",
      whyJoin: "لماذا تنضم إلينا؟",
      benefits: [
        { icon: "Users", title: "فريق ديناميكي", description: "اعمل مع محترفين أفارقة متحمسين." },
        { icon: "TrendingUp", title: "النمو", description: "تطور في شركة سريعة التوسع." },
        { icon: "GraduationCap", title: "التدريب", description: "طور مهاراتك باستمرار." },
        { icon: "Heart", title: "الرفاهية", description: "بيئة عمل إيجابية وشاملة." }
      ],
      jobsTitle: "الوظائف المتاحة",
      applyButton: "تقدم",
      spontaneous: {
        title: "طلب توظيف تلقائي",
        description: "أرسل سيرتك الذاتية لفرص مستقبلية.",
        button: "أرسل طلبي"
      }
    },
    presencePage: {
      title: "تواجدنا في أفريقيا",
      description: "مقرنا في أبيدجان، نغطي القارة الأفريقية بأكملها بشبكة من الشركاء المحليين.",
      officesTitle: "مكاتبنا",
      officesDescription: "تواصل مع فريقنا لخدمة شخصية.",
      regionsTitle: "المناطق المخدومة",
      regionsDescription: "شبكتنا تغطي الاقتصادات الأفريقية الرئيسية."
    },
    footer: {
      description: "شريكك الموثوق لتوزيع المواد الكيميائية في أفريقيا.",
      company: "الشركة",
      services: "الخدمات",
      legal: "اتصل بنا",
      rights: "جميع الحقوق محفوظة.",
      links: {
        about: "من نحن",
        team: "فريقنا",
        careers: "الوظائف",
        news: "الأخبار",
        distribution: "التوزيع",
        warehouse: "التخزين",
        logistics: "اللوجستيات",
        solutions: "حلول مخصصة",
        privacy: "الخصوصية",
        terms: "الشروط",
        cookies: "ملفات تعريف الارتباط"
      }
    },
    common: {
      learnMore: "اعرف المزيد",
      backToMarkets: "العودة للأسواق",
      contactExperts: "تواصل مع خبرائنا",
      markets: "الأسواق",
      otherMarkets: "أسواق أخرى"
    },
    partners: {
      eyebrow: "شركاؤنا",
      title: "يثقون بنا",
      description: "نتعاون مع رواد عالميين في الكيمياء المتخصصة لضمان جودة كل منتج نقدمه لعملائنا الأفارقة."
    }
  }
};

// Office locations - Only Abidjan headquarters
export const offices = {
  fr: [
    {
      id: 1,
      region: "Siège Social",
      city: "Abidjan, Côte d'Ivoire",
      address: "30, Rue Le Bon Trajet",
      addressLine2: "Riviera 4 M'Badon",
      phone: "+225 07 0702 8842",
      email: "admin@boidy-sarlu.com",
      email2: "claude.ntah@boidy-sarlu.com"
    }
  ],
  en: [
    {
      id: 1,
      region: "Headquarters",
      city: "Abidjan, Ivory Coast",
      address: "30, Rue Le Bon Trajet",
      addressLine2: "Riviera 4 M'Badon",
      phone: "+225 07 0702 8842",
      email: "admin@boidy-sarlu.com",
      email2: "claude.ntah@boidy-sarlu.com"
    }
  ],
  es: [
    {
      id: 1,
      region: "Sede Central",
      city: "Abidján, Costa de Marfil",
      address: "30, Rue Le Bon Trajet",
      addressLine2: "Riviera 4 M'Badon",
      phone: "+225 07 0702 8842",
      email: "admin@boidy-sarlu.com",
      email2: "claude.ntah@boidy-sarlu.com"
    }
  ],
  ar: [
    {
      id: 1,
      region: "المقر الرئيسي",
      city: "أبيدجان، ساحل العاج",
      address: "30, Rue Le Bon Trajet",
      addressLine2: "Riviera 4 M'Badon",
      phone: "+225 07 0702 8842",
      email: "admin@boidy-sarlu.com",
      email2: "claude.ntah@boidy-sarlu.com"
    }
  ]
};

// African regions served
export const regions = {
  fr: [
    {
      name: "Afrique de l'Ouest",
      description: "Notre zone d'expertise principale avec une présence forte dans la région UEMOA.",
      countries: ["Côte d'Ivoire", "Sénégal", "Mali", "Burkina Faso", "Niger", "Bénin", "Togo", "Ghana"]
    },
    {
      name: "Afrique Centrale",
      description: "Expansion en cours dans les marchés à fort potentiel de croissance.",
      countries: ["Cameroun", "Gabon", "Congo", "RDC", "Tchad"]
    },
    {
      name: "Afrique du Nord",
      description: "Partenariats stratégiques pour servir les marchés maghrébins.",
      countries: ["Maroc", "Tunisie", "Algérie"]
    }
  ],
  en: [
    {
      name: "West Africa",
      description: "Our main expertise zone with strong presence in the WAEMU region.",
      countries: ["Ivory Coast", "Senegal", "Mali", "Burkina Faso", "Niger", "Benin", "Togo", "Ghana"]
    },
    {
      name: "Central Africa",
      description: "Ongoing expansion in high-growth potential markets.",
      countries: ["Cameroon", "Gabon", "Congo", "DRC", "Chad"]
    },
    {
      name: "North Africa",
      description: "Strategic partnerships to serve Maghreb markets.",
      countries: ["Morocco", "Tunisia", "Algeria"]
    }
  ],
  es: [
    {
      name: "África Occidental",
      description: "Nuestra zona principal de experiencia con fuerte presencia en la región UEMOA.",
      countries: ["Costa de Marfil", "Senegal", "Malí", "Burkina Faso", "Níger", "Benín", "Togo", "Ghana"]
    },
    {
      name: "África Central",
      description: "Expansión en curso en mercados de alto potencial de crecimiento.",
      countries: ["Camerún", "Gabón", "Congo", "RDC", "Chad"]
    },
    {
      name: "África del Norte",
      description: "Alianzas estratégicas para servir los mercados del Magreb.",
      countries: ["Marruecos", "Túnez", "Argelia"]
    }
  ],
  ar: [
    {
      name: "غرب أفريقيا",
      description: "منطقة خبرتنا الرئيسية مع تواجد قوي في منطقة UEMOA.",
      countries: ["ساحل العاج", "السنغال", "مالي", "بوركينا فاسو", "النيجر", "بنين", "توغو", "غانا"]
    },
    {
      name: "وسط أفريقيا",
      description: "توسع مستمر في الأسواق ذات إمكانات النمو العالية.",
      countries: ["الكاميرون", "الغابون", "الكونغو", "جمهورية الكونغو الديمقراطية", "تشاد"]
    },
    {
      name: "شمال أفريقيا",
      description: "شراكات استراتيجية لخدمة أسواق المغرب العربي.",
      countries: ["المغرب", "تونس", "الجزائر"]
    }
  ]
};

// Job listings
export const jobs = {
  fr: [
    {
      id: 1,
      title: "Commercial Régional",
      location: "Abidjan, Côte d'Ivoire",
      type: "CDI",
      department: "Ventes",
      description: "Développer notre portefeuille clients en Afrique de l'Ouest."
    },
    {
      id: 2,
      title: "Responsable Logistique",
      location: "Abidjan, Côte d'Ivoire",
      type: "CDI",
      department: "Opérations",
      description: "Coordonner les opérations logistiques régionales."
    }
  ],
  en: [
    {
      id: 1,
      title: "Regional Sales Manager",
      location: "Abidjan, Ivory Coast",
      type: "Full-time",
      department: "Sales",
      description: "Develop our client portfolio in West Africa."
    },
    {
      id: 2,
      title: "Logistics Manager",
      location: "Abidjan, Ivory Coast",
      type: "Full-time",
      department: "Operations",
      description: "Coordinate regional logistics operations."
    }
  ],
  es: [
    {
      id: 1,
      title: "Gerente Comercial Regional",
      location: "Abidján, Costa de Marfil",
      type: "Tiempo completo",
      department: "Ventas",
      description: "Desarrollar nuestra cartera de clientes en África Occidental."
    },
    {
      id: 2,
      title: "Gerente de Logística",
      location: "Abidján, Costa de Marfil",
      type: "Tiempo completo",
      department: "Operaciones",
      description: "Coordinar operaciones logísticas regionales."
    }
  ],
  ar: [
    {
      id: 1,
      title: "مدير مبيعات إقليمي",
      location: "أبيدجان، ساحل العاج",
      type: "دوام كامل",
      department: "المبيعات",
      description: "تطوير محفظة عملائنا في غرب أفريقيا."
    },
    {
      id: 2,
      title: "مدير اللوجستيات",
      location: "أبيدجان، ساحل العاج",
      type: "دوام كامل",
      department: "العمليات",
      description: "تنسيق العمليات اللوجستية الإقليمية."
    }
  ]
};

// Languages available
export const languages = [
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "en", name: "English", flag: "🇬🇧" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "ar", name: "العربية", flag: "🇸🇦", rtl: true }
];

// Default language
export const defaultLanguage = "fr";
